export const relationFormFields = (statusList) => [
  {
    type: "text",
    name: "companyName",
    label: "Company Name",
    validation: (value) => (!value ? "Company name is required" : null),
  },
  {
    type: "email",
    name: "email",
    label: "Email Address",
    readOnly: true,
    validation: (value) => (!value ? "Email is required" : null),
  },
  {
    type: "phone",
    name: "phone",
    label: "Phone Number",
  },
  {
    type: "select",
    name: "status",
    label: "Status",
    options: Object.entries(statusList).map(([key, value]) => ({ key, value: (value as { name }).name })),
  },
  {
    type: "url",
    name: "website",
    label: "Website",
  },
];